import React, { useState, useEffect, useRef, useCallback } from "react";

import { Button } from "semantic-ui-react";
import { ITableAppRender } from "../../components/TableApp";
import TemplateTable from "../../components/TemplateTable";
import CadastrarOperador from "./CadastrarOperador";

import { ISearch } from "../../components/Search";
import { IOperador, ISearchResponse } from "../../interfaces"

import OperatorRepository from "../../Repositories/OperatorRepository";
import errors from "../../Utils/ExtractErrors";
import { toast } from "react-toastify";
import { IFields } from "../../components/Search/FilterBuilder";
import ModalYesNo from "../../components/ModalYesNo";
import { GetUser } from "../../services/auth";
import UsuarioRepository from "../../Repositories/UsuarioRepository";


const Operators: React.FC = () => {

    const [list, setList] = useState<IOperador[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const refSearch = useRef<ISearch>({ searchString: "", type: "simples" });
    const refRecordsByPage = useRef<number>(20);
    const refPageNumber = useRef<string | number | undefined>(1);
    const refTotalRecords = useRef<number>(0);
    const refTotalPages = useRef<number>(1);

    const { role } = GetUser();

    const onChangeRecords = (value: number) => {
        refRecordsByPage.current = value;
        load();
    }

    const onPageChange = (pageNumber: string | number | undefined) => {
        refPageNumber.current = pageNumber;
        load();
    }

    const load = useCallback(async () => {
        setLoading(true);
        try {

            let response: ISearchResponse<IOperador>;

            if (refSearch.current.type === "simples") {
                response = await OperatorRepository.List({
                    search: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            } else {
                response = await OperatorRepository.List({
                    filter: refSearch.current.searchString,
                    pageNumber: refPageNumber.current,
                    recordsByPage: refRecordsByPage.current
                });
            }

            refTotalRecords.current = response.totalRecords;
            refTotalPages.current = response.totalPages;

            setList(response.list);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }

        setLoading(false);
    }, []);

    const onSearch = ({ searchString, type }: ISearch) => {
        refSearch.current.searchString = searchString;
        refSearch.current.type = type;

        load();
    }

    useEffect(() => { load() }, [load]);

    const tableRender: ITableAppRender[] = [
        {
            header: "Nome",
            content: (a: IOperador) => a.nome,
            textAlign: "left"
        }
    ];

    const fields: IFields[] = [
        { label: "Operador", name: "Nome", type: "string", roles: ["Admin", "Operador"] }
    ];

    const onReset = async (id: string) => {
        try {
            const response = await UsuarioRepository.Reset({ id });

            toast(`🔑 ${response.message}`, { position: "top-center", type: "success" });
            load();
        } catch (error) {
            return toast("❌ Erro ao resetar a senha.", { position: "top-center", type: "error" });
        }
    }
    
    return (
        <TemplateTable
            title="Operadores"
            icon="users"
            insert={<CadastrarOperador onSuccess={load} />}

            searchPlaceHolder={"Nome"}
            onSearch={onSearch}
            filterFields={fields}

            tableLoading={loading}
            tableRender={tableRender}
            tableList={list}
            tableActions={(data: IOperador, index: number) => [
                <Button icon="pencil" />, 
                <ModalYesNo
                    trigger={
                        role === "Admin" &&
                        <Button
                            icon="refresh"
                            color="green"
                        />
                    }
                    header="Resetar senha"
                    content={`Deseja realmente resetar a senha do usuario ${data.nome}`}
                    onSuccess={() => onReset(data.id || "")}
                />
            ]}
            tablePagination={{
                currentPage: refPageNumber.current,
                totalRecords: refTotalRecords.current,
                totalPages: refTotalPages.current,
                onPageChange: onPageChange
            }}
            tableOnChangeRecords={onChangeRecords}
        />
    );
};

export default Operators;
